import {useStripeTestEnv} from 'app/utils/envUtils';

export const STRIPE_API_KEY = useStripeTestEnv
  ? 'pk_test_FyQLZnD7ra4YjsEr2hYImdKN'
  : 'pk_live_UXVhffZesv3DY2GEgqOGQSJK';
